import { createSlice } from "@reduxjs/toolkit"; 

const healthSafetySlice = createSlice({
  name: "healthSafety",
  initialState: {
    currentReport: null,
    reports: [],
    notifications: [],
    findings: [],
    findingsCount: 0,
    findingsLoaded: false,
    findingsLastFiltersKey: "",
    isFetchingFindings: false,
    isFetchingFindingsCount: false,
    findingsError: false,
    findingsCountError: false,
    isFetching: false,
    error: false
  },
  reducers: {
    // Acciones para crear informes
    createHealthSafetyReportStart: (state) => {
      state.isFetching = true;
    },
    createHealthSafetyReportSuccess: (state, action) => {
      state.isFetching = false;
      state.currentReport = action.payload;
      state.error = false;
    },
    createHealthSafetyReportFailure: (state) => {
      state.currentReport = null;
      state.isFetching = false;
      state.error = true;
    },
    
    // Acciones para obtener informes
    getHealthSafetyReportsStart: (state) => {
      state.isFetching = true;
    },
    getHealthSafetyReportsSuccess: (state, action) => {
      state.reports = action.payload;
      state.isFetching = false;
      state.error = false;
    },
    getHealthSafetyReportsFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    
    // Acciones para notificaciones
    getNotificationsStart: (state) => {
      state.isFetching = true;
    },
    getNotificationsSuccess: (state, action) => {
      state.notifications = action.payload;
      state.isFetching = false;
      state.error = false;
    },
    getNotificationsFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },

    getFindingsCountStart: (state) => {
      state.isFetchingFindingsCount = true;
      state.findingsCountError = false;
    },
    getFindingsCountSuccess: (state, action) => {
      state.findingsCount = Number(action.payload || 0);
      state.isFetchingFindingsCount = false;
      state.findingsCountError = false;
    },
    getFindingsCountFailure: (state) => {
      state.isFetchingFindingsCount = false;
      state.findingsCountError = true;
    },

    getFindingsStart: (state, action) => {
      state.isFetchingFindings = true;
      state.findingsError = false;
      state.findingsLastFiltersKey = action.payload || "";
    },
    getFindingsSuccess: (state, action) => {
      state.findings = Array.isArray(action.payload) ? action.payload : [];
      state.findingsLoaded = true;
      state.isFetchingFindings = false;
      state.findingsError = false;
    },
    getFindingsFailure: (state) => {
      state.isFetchingFindings = false;
      state.findingsError = true;
    },
    
    // Acciones para actualizar estado de lectura
    updateNotificationReadStart: (state) => {
      state.isFetching = true;
    },
    updateNotificationReadSuccess: (state, action) => {
      state.isFetching = false;
      state.error = false;
    },
    updateNotificationReadFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    
    // Acciones para eliminar informes
    deleteHealthSafetyReportStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    deleteHealthSafetyReportSuccess: (state, action) => {
      state.currentReport = action.payload;
      state.isFetching = false;
      state.error = false;
    },
    deleteHealthSafetyReportFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    logoutHealthSafetyReport: (state) => {
      state.currentReport = [];
      state.reports = [];
      state.notifications = [];
      state.findings = [];
      state.findingsCount = 0;
      state.findingsLoaded = false;
      state.findingsLastFiltersKey = "";
      state.isFetchingFindings = false;
      state.isFetchingFindingsCount = false;
      state.findingsError = false;
      state.findingsCountError = false;
      state.isFetching = false;
      state.error = false;
    },
    updateReportAndNotificationStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    updateReportAndNotificationSuccess: (state, action) => {
      state.isFetching = false;
      state.error = false;
      const { report } = action.payload || {};
      // guardo en currentReport lo devuelto
      state.currentReport = report || null;
    
      // si hay lista en memoria, actualizo/inyecto el reporte actualizado
      if (report) {
        const idx = state.reports.findIndex(r => r.id === report.id);
        if (idx !== -1) {
          state.reports[idx] = report;
        } else {
          // si no estaba, lo agrego al inicio (opcional)
          state.reports.unshift(report);
        }
      }
    },
    updateReportAndNotificationFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});

export const { 
  createHealthSafetyReportStart, 
  createHealthSafetyReportSuccess, 
  createHealthSafetyReportFailure,
  getHealthSafetyReportsStart,
  getHealthSafetyReportsSuccess,
  getHealthSafetyReportsFailure,
  getNotificationsStart,
  getNotificationsSuccess,
  getNotificationsFailure,
  getFindingsCountStart,
  getFindingsCountSuccess,
  getFindingsCountFailure,
  getFindingsStart,
  getFindingsSuccess,
  getFindingsFailure,
  updateNotificationReadStart,
  updateNotificationReadSuccess,
  updateNotificationReadFailure,
  deleteHealthSafetyReportStart,
  deleteHealthSafetyReportSuccess,
  deleteHealthSafetyReportFailure,
  logoutHealthSafetyReport,
  updateReportAndNotificationStart,
  updateReportAndNotificationSuccess,
  updateReportAndNotificationFailure,
} = healthSafetySlice.actions;

export default healthSafetySlice.reducer; 
